import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import { withSnackbar } from "notistack"
import { Paper, Table, TableBody } from "@material-ui/core"
import { STableLoader, STabsLoader } from "../../../shared_elements/loaders"
import { PageLoader, EmptyCollection, AssetAddDropdown, AccessDenied } from "../../../shared_elements"
import Pagination from "../../../shared_elements/components/Pagination"
import { AssetList, AssetListTab, EngineAssetHd, AssetListHd } from "../components"
import { convertFilterObject, removeEmptyKey, checkApiStatus, downloadFileType, getLocalStorageInfo } from "../../../utils"
import { getAircraftTypesAc, getEngineFamilyAc, getEngineTypesAc, getLesseeListAc, getOperatorListAc, getLeaseStatus, getSubStatus } from "../../../shared_elements/actionCreators"
import { maintenanceFilterOps, smbcFilters } from "../"
import { globalGetService, globalExportService } from "../../../utils/globalApiServices"
import { trackActivity } from "../../../utils/mixpanel"
import { halcyonInstance, smbcInstance } from "../../../shared_elements/components"
import DeploymentMessage from "../../../shared_elements/components/DeploymentMessage"
import FilterComponent from "../../../shared_elements/components/filter_component"
import { permissionCheckFnforCamo } from "../../../utils"
import {ExportMenu} from "../../../shared_elements"
const AssetListing = (props) => {
    const { aircraftTypes, engineFamily, engineTypes, lessees, operators, enqueueSnackbar, getLesseeList, getOperatorList, getEngineTypes, getEngineFamily, getAircraftTypes, getLeaseStatus: fetchLeaseStatus, getSubStatus: fetchSubStatus } = props
    const [skeletonLoader, setSkeletonLoader] = useState(false)
    const [pageLoader, setPageLoader] = useState(false)
    const [tabIndex, setTabIndex] = useState(smbcInstance || halcyonInstance ? 2 : 0)
    const [sort, setSort] = useState("")
    const [sort_by, setSortBy] = useState("")
    const [assets, setAssets] = useState({ list: [], pagination: {}, asset_count: {} })
    const [filter, setFilter] = useState({})
    const [applyingFilter, setApplyingFilter] = useState({})


    const getAssetList = (queryParams = {}, loaderType) => {
        loaderType === "skeletonLoader" ? setSkeletonLoader(true) : setPageLoader(true)
        globalGetService(`console/list/?lite=1`, { ...queryParams, per_page: queryParams?.per_page || 250, application: 18 })
            .then((response) => {
                loaderType === "skeletonLoader" ? setSkeletonLoader(false) : setPageLoader(false)
                if (checkApiStatus(response)) {
                    delete queryParams?.page
                    delete queryParams?.per_page
                    setFilter(queryParams)
                    setAssets((prev) => ({
                        ...prev,
                        asset_count: response.data?.data?.asset_count,
                        list: response.data.data?.asset,
                        pagination: {
                            ...prev.pagination,
                            total: response.data.data?.pagination?.total,
                            per_page: response?.data?.data?.pagination?.per_page,
                            page: parseInt(response?.data.data?.pagination?.current_page),
                        },
                    }))
                }
            })
    }

    const exportAssetList = (queryParams = {}) => {
        setPageLoader(true)
        globalExportService(`/console/list/`, { ...queryParams, asset_type: queryParams.asset_type, application: 18 })
            .then((response) => {
                setPageLoader(false)
                downloadFileType(response.data, `${getLocalStorageInfo().defaultLessor.name}_Assets`, queryParams.download)
                enqueueSnackbar("Download of Asset List successful", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } })
                trackActivity("Item Exported", { page_title: "Asset Listing" })
            })
    }
    const savedFilter = localStorage.getItem("savedFilterValue")
    const savedSorting = localStorage.getItem("sortField")
    const parsedFilter = savedFilter ? JSON.parse(savedFilter) : null
    const parsedSorting = savedSorting ? JSON.parse(savedSorting) : null

    // Applies any stored filter/sort from localStorage and calls getAssetList.
    // clearOnEmpty: when true and no saved state exists, resets filter/applyingFilter (used on tab change).
    const loadAssetsWithStoredState = (loaderType, extraParams = {}, clearOnEmpty = false) => {
        if (parsedFilter) setFilter(parsedFilter)
        if (parsedSorting) {
            setSort(parsedSorting?.sort)
            setSortBy(parsedSorting?.sort_by)
        }
        if (!parsedFilter && !parsedSorting && clearOnEmpty) {
            setApplyingFilter({})
            setFilter({})
        }
        getAssetList({ ...(parsedFilter || {}), ...(parsedSorting || {}), ...extraParams }, loaderType)
    }

    useEffect(() => {
        getLesseeList()
        getOperatorList()
        getEngineTypes()
        getEngineFamily()
        getAircraftTypes()
        fetchLeaseStatus()
        fetchSubStatus()
        trackActivity("CAMO", { event_type: "Page Visited", page_title: "Asset Listing" })
        loadAssetsWithStoredState("skeletonLoader", { per_page: 250 })
    }, [])

    const onTabChange = (e, newValue) => {
        setTabIndex(newValue)
        loadAssetsWithStoredState("pageLoader", { per_page: 250, ...(newValue !== 0 && { asset_type: newValue }) }, true)
    }

    const createSortHandler = (sortField, clear) => {
        if (clear) {
            localStorage.removeItem("sortField")
            setSort("")
            setSortBy("")
            delete filter.sort
            delete filter.sort_by
            getAssetList({ ...filter, per_page: 250, asset_type: tabIndex }, "pageLoader")
        } else {
            const newSortBy = sortField === sort ? (sort_by === "asc" ? "desc" : "asc") : "asc"
            setSort(sortField)
            setSortBy(newSortBy)
            localStorage.setItem("sortField", JSON.stringify({ sort: sortField, sort_by: newSortBy }))
            getAssetList({ ...filter, sort: sortField, sort_by: newSortBy, per_page: 250, asset_type: tabIndex }, "pageLoader")
        }
    }

    let filterOptions = { ...maintenanceFilterOps }
    if (tabIndex === 0 || tabIndex === 1) {
        filterOptions = { ...filterOptions, aircraft_type: { ...filterOptions.aircraft_type, options: aircraftTypes } }
        if (tabIndex === 1) delete filterOptions.engine_type
    }
    if (tabIndex === 0 || tabIndex === 2) {
        filterOptions = { ...filterOptions, engine_type: { ...filterOptions.engine_type, options: engineTypes } }
        if (tabIndex === 2) {
            delete filterOptions.aircraft_type
            delete filterOptions.registration
        }
    }
    filterOptions = {
        ...filterOptions,
        lessee: { ...filterOptions.lessee, options: lessees },
        operator: { ...filterOptions.operator, options: operators },
    }

    let assetFilterObj = { ...filter }
    delete assetFilterObj["asset_type"]

    const appliedFilterObj = { ...filter }
    delete appliedFilterObj["asset_type"]
    delete appliedFilterObj["sort"]
    delete appliedFilterObj["sort_by"]

    const smbcfilterOptions = {
        ...smbcFilters,
        engine_family: { ...smbcFilters.engine_family, options: engineFamily || [] },
        engine_type: { ...smbcFilters.engine_type, options: engineTypes || [] },
        operator: { ...smbcFilters.operator, options: operators || [] },
        lessee: { ...smbcFilters.lessee, options: lessees || [] },
    }

    const parsedSort = JSON.parse(localStorage.getItem("sortField") || "{}")
    const tabsLoaderCount = window.innerWidth < 768 ? 3 : window.innerWidth < 1024 ? 5 : 9;
    return (
        <section className="asset-listing-section">
            {permissionCheckFnforCamo({ primaryKey: "asset_management", keyIndex: "R" }) ? <>
                <DeploymentMessage />
                {/* <h3 className="asset-list-heading">Assets</h3> */}
                {skeletonLoader ? <STabsLoader count={tabsLoaderCount} /> : <>
                    <AssetListTab item={assets} onTabChange={onTabChange} tabIndex={tabIndex} />
                    <Paper square className="plt-filter-comp d-flex align-items-center">
                        <FilterComponent
                            savedFilterValue={true}
                            filter={appliedFilterObj}
                            filterMenu={smbcInstance ? smbcfilterOptions : filterOptions}
                            getResponseBack={(applyFilter) => getAssetList({ ...applyFilter, sort: parsedSort?.sort, sort_by: parsedSort?.sort_by, asset_type: tabIndex, per_page: 200 }, "pageLoader")}
                        />
                        {assets.list.length ? (
                            <div className="d-flex align-items-center">
                                <span style={{marginInline:'8px'}}>
                                    <ExportMenu
                                        exportReportFn={(file) => exportAssetList({ download: file.extension, ...convertFilterObject(removeEmptyKey(applyingFilter), filterOptions), asset_type: tabIndex, ...assetFilterObj })}
                                        files={[{ title: 'PDF', extension: 'pdf' }, { title: 'EXCEL', extension: 'xlsx' }]}
                                        title='EXPORT'
                                    />
                                </span>
                                <span className="add-asset-cta"><AssetAddDropdown /></span>
                            </div>
                        ) : null}
                    </Paper> </>}
                {skeletonLoader ? <STableLoader count={tabsLoaderCount} /> :
                    <Paper square  variant="outlined">
                        <div style={{ height: `${window.innerHeight - 270}px`, overflow: 'auto' }}>
                            <Table className="mui-table-format" stickyHeader={true}>
                                {tabIndex === 2
                                    ? <EngineAssetHd sort={sort} sort_by={sort_by} createSortHandler={createSortHandler} />
                                    : <AssetListHd sort={sort} sort_by={sort_by} createSortHandler={createSortHandler} />
                                }
                                <TableBody>
                                    {assets?.list?.map((item, index) => (
                                        <AssetList
                                            key={index}
                                            item={item}
                                            index={index}
                                            props={props}
                                            tabIndex={tabIndex}
                                        />
                                    ))}
                                </TableBody>
                            </Table>
                            {!assets?.list?.length ? <EmptyCollection title="No Records Found" /> : null}
                        </div>
                        <Pagination
                            pagination={assets?.pagination}
                            onChangePage={(_event, newPage) => getAssetList({ ...convertFilterObject(removeEmptyKey({ ...applyingFilter, ...parsedFilter, ...parsedSorting, asset_type: tabIndex, per_page: assets.pagination.per_page, page: newPage + 1 }), filterOptions) }, "pageLoader")}
                            onChangeRowsPerPage={(event) => getAssetList({ ...convertFilterObject(removeEmptyKey({ ...applyingFilter, ...parsedFilter, ...parsedSorting, asset_type: tabIndex, per_page: event.target.value }), filterOptions) }, "pageLoader")}
                        />
                    </Paper>}
                {pageLoader ? <PageLoader /> : null}
            </> : <AccessDenied />
            }
        </section>
    )
}

const mapStateToProps = (state) => ({
    aircraftTypes: state.shareReducer.aircraftTypes,
    engineFamily: state.shareReducer.engineFamily,
    engineTypes: state.shareReducer.engineTypes,
    lessees: state.shareReducer.lessees,
    operators: state.shareReducer.operators,
    leaseStatus: state.shareReducer.leaseStatus,
    subStatus: state.shareReducer.subStatus,
})

const mapDispatchToProps = (dispatch) => ({
    getAircraftTypes: (props, query) => dispatch(getAircraftTypesAc(props, query)),
    getEngineFamily: () => dispatch(getEngineFamilyAc({ active: true })),
    getEngineTypes: () => dispatch(getEngineTypesAc({ distinct: 1 })),
    getLesseeList: () => dispatch(getLesseeListAc("", { distinct: 1 })),
    getOperatorList: () => dispatch(getOperatorListAc("", { distinct: 1 })),
    getLeaseStatus: () => dispatch(getLeaseStatus({ constant_types: ["lease_status"] })),
    getSubStatus: () => dispatch(getSubStatus({ constant_types: ["asset_sub_status"] })),
})

export default withSnackbar(connect(mapStateToProps, mapDispatchToProps)(AssetListing))
